import {FlightSearchStepBase} from "./flight-search-step.base";


export class DestinationStationSelectionStep extends FlightSearchStepBase {

    get title(): string {
        return this.services.language.translate('Destination');
    }

    async next(): Promise<void> {
        const searchController = this.services.flightSearch.searchController
        const psoMarket = await searchController.getPsoMarketAsync();
        if(psoMarket?.allowNewBookings) {
           await this._showPsoConfirmationDialog(searchController, psoMarket, this.routes.flightDates);
        } else {
            this._activateStepByRoute(this.routes.flightDates)
        }

    }


    get route() {
        return this.routes.destinationStation;
    }


}
